export default class InputField {
    public id: string;
    public focused: boolean;

    constructor(fieldId: string, isFocused: boolean = false) {
        this.focused = isFocused;
        this.id = fieldId;
    }
}
